<template>
    <div>
        <vueHeader :navNum="0"></vueHeader>

        <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide v-for="(item,index) in bannerList" :key="index">
                <div class="banner" @click="$router.push(item.path)">
                    <img :src="item.img" alt="">
                </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        <ul class="field wrap">
            <li v-for="(item,index) in field" :key="index">
                <router-link :to="item.path">
                    <img :src="item.img" :alt="item.title">
                    <p class="title">{{item.title}}</p>
                    <p class="msg">{{item.msg}}</p>
                </router-link>
            </li>
        </ul>

        <div class="picture wrap">
            <div class="title">
                <img class="picture_title" src="./../assets/img/picture.png" />
                <img class="title_desc" src="./../assets/img/title_desc.png" />
                <p>精彩图集</p>
                <router-link to="/medicalList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <div class="picBox">
                <div class="left">
                    <div class="item img1" @click="goArtical('medical',12)">
                        <img src="./../assets/img/picture/t1@2x.jpg" />
                        <div class="introduce">
                            <div class="content">
                                <p class="headline">血液细胞可彻底转化为脑细胞</p>
                                <p class="txt">致力于更好的帮助睡眠呼吸障碍的病人之外...</p>
                            </div>
                            <div class="go">
                                <img src="./../assets/img/go.png" />
                            </div>
                        </div>
                    </div>
                    <div class="item img2" @click="goArtical('medical',11)">
                        <img src="./../assets/img/picture/t2@2x.jpg" />
                        <div class="introduce">
                            <div class="content">
                                <p class="headline">致胎儿缺陷的“染色体秘密”揭开</p>
                                <p class="txt">“染色体非整倍性”是导致人类不孕不育...</p>
                            </div>
                            <div class="go">
                                <img src="./../assets/img/go.png" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="center">
                    <div class="item img3" @click="goArtical('health',7)">
                        <img src="./../assets/img/picture/t3@2x.jpg" />
                        <div class="introduce">
                            <div class="content">
                                <p class="headline">新鲜的咖啡到底指的是哪些？</p>
                                <p class="txt">"趁热吃"是生活中经常出现的词语...</p>
                            </div>
                            <div class="go">
                                <img src="./../assets/img/go.png" />
                            </div>
                        </div>
                    </div>
                    <div class="item img4" @click="goArtical('travel',1)">
                        <img src="./../assets/img/picture/t4@2x.jpg" />
                        <div class="introduce">
                            <div class="content">
                                <p class="headline">一次性认清阿尔卑斯山脉十大名峰</p>
                                <p class="txt">石丹峰位于上瓦尔登和下瓦尔登的交界处...</p>
                            </div>
                            <div class="go">
                                <img src="./../assets/img/go.png" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="item img5" @click="goArtical('horse',6)">
                        <img src="./../assets/img/picture/t5@2x.png" />
                        <div class="introduce">
                            <div class="content">
                                <p class="headline">马术的发展历史你知道多少？</p>
                                <p class="txt">马在历史上与人类有非常亲密的关系...</p>
                            </div>
                            <div class="go">
                                <img src="./../assets/img/go.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="about">
            <div class="content">
                <p class="headline">关于我们</p>

                <p class="eng">About Lotohof</p>
                <div class="history">
                    <p class="txt txt1">Lotohof是一家集互联网、医疗、健康、贸易为一体的企业，有为社会提供健康相关服务与前沿信息的使命。我们一直秉承着为我们的合作伙伴、患者和同仁提供最杰出的解决方案，并坚守诚信和最高道德标准。</p>
                    <p class="txt txt2">1999年开始我们的医疗行业业务，二十年间与各大医疗机构共同学习研发积累医学经验。至今仍与与数家大型医疗品牌进行密切的合作和业务往来，在医疗领域稳稳立足。目前公司经营的产品在同类型医疗器械产品中拥有最好的用户及口碑。</p>
                    <p class="txt txt3">2012年开始我们的健康领域业务，尝试引进德国石荷州抗衰老机构的胸腺肽细胞疗法，并与国内外抗衰老领域的权威专家有广泛合作和交流，在抗衰老方向有颇多建树和经验积累。同时我们开始涉足了中国德国之间的平行进口汽车贸易、德国波罗的海边的房地产开发，以及提供在德国的特别旅行和生活体验项目。</p>
                    <p class="txt txt4">2014年Lotohof在德国进入专业的马术领域。骑马是所有运动项目中对身体最有益处的高贵运动，而我们始终致力于将马术这项“贵族运动”带入更多人的生活，让越来越多的人体会到马术的魅力与好处。</p>
                </div>

            </div>
        </div>

        <div class="news wrap">
            <div class="title">
                <img class="picture_title" src="./../assets/img/news.png" />
                <img class="title_desc" src="./../assets/img/title_desc.png" />
                <p>新闻资讯</p>
                <router-link to="/medicalList">
                    <div class="more">more</div>
                </router-link>
            </div>
            <div class="box">
                <div class="item" v-for="(item,index) in news" :key="index" @click="goArtical(item.from,item.id)">
                    <div class="time">
                        <p class="day">{{item.day}}</p>
                        <p class="year">{{item.year}}</p>
                    </div>
                    <div class="mask">
                        <p class="title">{{item.title}}</p>
                        <p class="content">{{item.content}}</p>
                    </div>
                </div>
            </div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
import 'swiper/dist/css/swiper.css'
export default {
    data() {
        return {
            bannerList: [
                {
                    img:require('./../assets/img/index/banner1.jpg'),
                    path: '/medical'
                },
                {
                    img:require('./../assets/img/index/banner2.jpg'),
                    path: '/health'
                },
                {
                    img:require('./../assets/img/index/banner3.jpg'),
                    path: '/travel'
                },
                {
                    img:require('./../assets/img/index/banner4.jpg'),
                    path: '/horsemanship'
                },
            ],
            swiperOption: {
                notNextTick: true,
                loop: true, //循环
                initialSlide: 1, //设定初始化时slide的索引
                //autoplay: false, //自动播放
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                effect: "fade", // 设置轮播
                fadeEffect: {
                    crossFade: true
                },
                speed: 1200, //滑动速度
                direction: "horizontal", //滑动方向
                // grabCursor : true, //小手掌抓取滑动
                on: {
                    click: function(){
                        console.log('点击')
                    }
                },
                pagination: {
                    //分页器设置
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            field: [
                {
                    path: '/medical',
                    img: require('./../assets/img/index/field_medical.png'),
                    title: '医疗领域',
                    msg: '自一九九九年起我们一直在医疗领域，是浙江省内最早涉及到科学地应对术中气道管理和血液动力学的专业公司之一。二十年间，公司积累医学经验，不断引进、更新公司产品，增加公司产品市场竞争优势，稳定立足医疗领域。',
                },
                {
                    path: '/health',
                    img: require('./../assets/img/index/field_health.png'),
                    title: '健康领域',
                    msg: '我们拥有全球领先的医学院资源和独立实验室研发产品，与国内外抗衰老领域的权威专家广泛合作和交流，也在试图引进德国石荷州抗衰老机构的细胞疗法。同时，我们一直努力向大众提供最新的信息和服务，为缓解和治疗疾病做出我们最大的努力。',
                },
                {
                    path: '/travel',
                    img: require('./../assets/img/index/field_travel.png'),
                    title: '旅行领域',
                    msg: '我们提供专业公司团队，根据您的旅行需求，为您度身定制在德国的特别旅行计划。我们为您的旅行设计特色旅游路线，全程专车专导，随时配合您调整行程，力求带给您一种与众不同的文化体验、一次毕生难忘的放松旅行。',
                },
                {
                    path: '/horsemanship',
                    img: require('./../assets/img/index/field_hof.png'),
                    title: '马术领域',
                    msg: '我们具有奥运选手和世锦赛选手的充足教学资源和丰富经验，并且我们也拥有最具潜质的优秀马匹及最为辽阔隽秀的马场。马术专业指导员为广大马术爱好者提供度身定制专业、优质的骑术训练课程，让越来越多的人体会到马术的魅力与好处。',
                }
            ],
            news: [
                {
                    day: '01-02',
                    year: '2019',
                    from: 'medical',
                    id: 12,
                    title: '血液细胞可彻底转化为脑细胞',
                    content: '科幻的变种人或超级英雄离我们遥远么？相信在不久的将来这些都将成为真实的存在。因为科学家最近发现了一种将免疫系统细胞转化为神经元的方法......'
                },
                {
                    day: '12-25',
                    year: '2018',
                    from: 'health',
                    id: 6,
                    title: '维生素E什么时候吃最好？',
                    content: '要想知道维生素e什么时候吃最好？首先让我们先了解下天然维生素E的功效。它是一种强有力的抗氧化剂，具有防衰老，抗癌，维持人体健康的多种功能......'
                },
                {
                    day: '12-23',
                    year: '2018',
                    from: 'horse',
                    id: 10,
                    title: '中国马术巡回赛广州总决赛正式启动',
                    content: '12月20日，由中国马术协会主办、中马国际承办的国际马术联合会（FEI）三星级场地障碍赛——浪琴表中国马术巡回赛香港赛马会杯广州总决赛新闻发功......'
                }
            ]
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    },

    methods: {
        goArtical(obj, id) {
            this.$store.commit('change' + obj + 'ArticalId', id);
            this.$router.push({ path: '/' + obj + 'Content' });
        }
    },

    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper;
        }
    },

    components: {
        vueHeader,
        vueFooter
    },
}
</script>

<style scoped lang="less">
@import "./../assets/css/index.less";
</style>


// WEBPACK FOOTER //
// src/views/index.vue